import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-40 p-4 bg-white rounded-full shadow-xl hover:shadow-2xl transition-shadow duration-300 group"
        >
          <div className="relative">
            {/* Background circle with gradient */}
            <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-gold-500 to-gold-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

            {/* Arrow icon */}
            <svg
              className="w-6 h-6 text-gold-600 group-hover:text-white relative z-10 transition-colors duration-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 10l7-7m0 0l7 7m-7-7v18"
              />
            </svg>

            {/* Ripple effect */}
            <motion.div
              className="absolute inset-0 rounded-full border-2 border-gold-500"
              initial={{ scale: 1 }}
              animate={{ scale: 1.5, opacity: [1, 0] }}
              transition={{
                duration: 1,
                repeat: Infinity,
                repeatType: "loop",
                ease: "easeOut",
              }}
            />
          </div>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
